<template>
  <div style="background: #F2F2F2;min-height:100vh;overflow: scroll;">
    <div class="normal-header">
      <div class="normal-header-inner">
        <img src="../assets/imgs/航眼logo/蓝色@2x.png">
        <ul>
          <li @click="toHome()">首页</li>
          <el-cascader :show-all-levels="false" v-model="industryConfig.industryConfigIdList" :options="industryConfigList" :props="optionProps" @change="handleCascaderChange" ref="cascader"> <template slot-scope="{ node, data }">
              <!--点击文本后选中整个节点-->
              <div @click="$event.srcElement.parentNode.previousElementSibling.click()">
                {{ data.name }}</div>
            </template></el-cascader>
          <!-- <li><span v-for="(item,index) in industryConfig.name" :key="index">{{ item}}<label v-if="index + 1 < industryConfig.name.length">></label></span></li> -->
          <!-- <li class="active">{{title}}</li> -->
        </ul>
      </div>
    </div>

    <div class="list-center">
      <ul class="nav-menu">
        <li @click="changeColumn(0)" :class="columnId==0 ? 'active' : ''">
          <img :src="columnId == 0 ? require('../assets/imgs/nav-active-icon1@2x.png') : require('../assets/imgs/nav-icon1@2x.png')">
          产品概览
        </li>
        <li v-for="(item,index) in columnList" :key="index" :class="columnId==item.columnId ? 'active' : ''" @click=" changeColumn(item,index)">
          <img :src="columnId==item.columnId ? item.iconCheck ? item.iconCheck : item.activeImg : item.iconUncheck ? item.iconUncheck : item.img">
          {{ item.name }}<span v-if="item.count">({{ item.count }})</span>
        </li>
      </ul>
      <div class="center-right">
        <div class="filtrate-box" v-if="columnId !=0">
          <ul>
            <li>
              <label>热门标签：</label>
              <ul class="need-check">
                <li @click="changeLabel(item)" :class="labelIds.indexOf(item.labelId) != -1 ? 'active' : ''" v-for=" (item,index) in labelList" :key="index">{{ item.name }}</li>
              </ul>
            </li>
            <li v-if="checkLabelList.length > 0">
              <label>当前选择：</label>
              <ul class="checked">
                <li v-for="(item,index) in checkLabelList" :key="index" class="active">{{ item.name }}<img src="../assets/imgs/choice-close@2x.png" @click="labelSplice(index)"></li>
                <li @click="labelsToNull">清空</li>
              </ul>
            </li>
          </ul>
          <div :class="labelList.length > 6 ? 'search long' : 'search short'">
            <el-select :popper-append-to-body="false" popper-class="select-popper" v-model="form.type" placeholder="请选择">
              <el-option v-for="(item,index) in typeList" :key="index" :label="item" :value="index+1">
              </el-option>
            </el-select>
            <div class="little-search-inner">
              <input v-model="form.key" type="text" placeholder="请输入" @input="inputChange" @keyup.enter="getArticleList">
              <img id="searchIcon" src="../assets/imgs/search-button-icon@2x.png" @click="getArticleList" :class="searchFlag ? 'point-icon' : ''">
            </div>
          </div>
        </div>

        <!-- {{ columnId != 0 && showStyle == 1 && ((jumpType == 'search'&& searchList.length > 0) || jumpType == 'block') && articleList.length > 0 }} -->
        <div class="table-box">
          <div v-if="columnId != 0 && showStyle == 0 && articleList.length > 0">
            <el-table :data="articleList" :header-cell-style="{
background: '#E8F4FE'}" :cell-style="{
'height': '60px','cursor': 'default'}" :stripe="true" style="width: 100%">
              <el-table-column label="标题" align="left" header-align="center">
                <template slot-scope="scope">
                  <!-- <span style="margin-left: 10px">{{ scope.row.date }}</span> -->
                  <span style="color: #4190F6;padding-left: 20px;display: block;word-wrap: normal;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;cursor: pointer;" @click="jumpArticleDetail(scope.row)">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column label="行业" align="left" header-align="left" width="150" key="industryConfigName" prop="industryConfigName" />
              <el-table-column label="标签" align="left" header-align="left" width="150" key="labelNames" prop="labelNames" />
              <el-table-column label="时间" align="left" header-align="center" width="100" key="date" prop="date" />
              <!-- <el-table-column label="来源" align="center" header-align="center" width="150" key="source" prop="source" /> -->
              <el-table-column label="收藏" align="center" header-align="center" width="80">
                <!-- <template slot-scope="scope">
      </template> -->
                <img src="../assets/imgs/star_grey@2x.png" style="width:17px;">
              </el-table-column>
              <el-table-column label="查看" align="center" header-align="center" width="80">
                <template slot-scope="scope">
                  <!-- <span style="margin-left: 10px">{{ scope.row.date }}</span> -->

                  <span style="color: #4190F6;cursor: pointer;" @click="jumpArticleDetail(scope.row)">查看</span>
                </template>
                <!-- <img src="../assets/imgs/pdf@2x.png" style="width:20px"> -->
              </el-table-column>
            </el-table>

            <el-pagination align='right' @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20]" :page-size="listPageSize" layout="total, prev, pager, next" :total="total" style="margin-top:10px">
            </el-pagination>
          </div>
          <!-- <list v-if="columnId != 0 && showStyle == 0 && ((jumpType == 'search'&& searchList.length > 0) || jumpType == 'block')" :searchValue="form.key" :searchType="form.type"></list> -->
          <!-- <about v-if="columnId != 0 && showStyle == 1 && ((jumpType == 'search'&& searchList.length > 0) || jumpType == 'block')" :searchValue="form.key" :searchType="form.type"></about> -->
          <div v-else-if="columnId != 0 && showStyle == 1 && articleList.length > 0">
            <ul class="block_ul">
              <li v-for="(item,index) in articleList" :key="index">
                <h3 class="title">{{ item.title }}</h3>
                <div class="image_box">
                  <img @click="jumpArticleDetail(item)" :src="item.image ? item.image[0] : require('../assets/imgs/default-img@2x.png')">
                </div>
                <p>{{ item.date }}<span>{{ item.industryConfigName }}</span></p>
                <div class="bottom_box">
                  {{ item.labelNames }}
                  <span @click="jumpArticleDetail(item)"><img src="../assets/imgs/read@2x.png">原文</span>
                </div>
              </li>
            </ul>
            <el-pagination align='right' @current-change="handleCurrentChange" :current-page="currentPage" :page-size="blockPageSize" layout="total, prev, pager, next" :total="total" style="margin-top:10px">
            </el-pagination>
          </div>
          <!-- <div class="none_page" v-else-if="columnId != 0 && articleList.length == 0">
            <img src="../assets/imgs/none.png">
          </div> -->
          <product v-else-if="columnId==0 && productFlag" @changeProductFlag="changeProductFlag"></product>
          <div class="none_page" v-else>
            <img src="../assets/imgs/none.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import product from "../components/product.vue";
import list from "../components/list.vue";
import about from "../components/about.vue";
import { apiGet, apiPost } from "../assets/http";
const baseUrl = "/dev-api";
// import { Loading } from "element-ui";
// let loading = Loading.service({
//   lock: true,
//   fullscreen: true,
//   text: "Loading...",
//   // spinner: "el-icon-loading",
//   background: "#FFF",
// });
export default {
  components: {
    product,
    list,
    about,
  },
  data() {
    return {
      baseUrl,
      showStyle: null,
      columnList: [],
      labelList: [],
      articleList: [],
      columnId: "",
      labelIds: [],
      checkLabelList: [], //已选择的标签列表
      searchList: [],
      typeList: ["标题检索", "全文检索", "作者检索", "关键词检索", "热词检索"],
      form: {
        key: null,
        type: 1,
      },
      jumpType: null, //search搜索 block产业
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      blockPageSize: 9, // 每页的数据条数
      listPageSize: 10,
      searchFlag: false,
      title: "",
      productFlag: false,
      industryConfig: {},
      optionProps: {
        value: "industryConfigId",
        label: "name",
        children: "children",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      // 行业配置列表
      industryConfigList: [],
    };
  },
  created() {
    this.industryConfigList = JSON.parse(
      sessionStorage.getItem("industryConfigList")
    );
    // console.log(this.industryConfigList);
    this.industryConfig = JSON.parse(sessionStorage.getItem("industryConfig"));
    let obj = {};
    // apiGet("/business/web/getSysConfig", {key:"sys.name"}).then((res) => {
    //    console.log(res)
    //   });
    if (Object.keys(this.$route.params).length != 0) {
      obj = this.$route.params;
      sessionStorage.setItem("pageObj", JSON.stringify(this.$route.params));
    } else {
      obj = JSON.parse(sessionStorage.getItem("pageObj"));
    }
    this.columnId = obj.columnId;
    this.title = sessionStorage.getItem("headerTitle");
    this.getColumnList();
    this.getLabelList();
    if (obj.type != null) {
      this.searchList = obj.list;
      this.form.type = obj.type;
      this.form.key = obj.key || null;
    } else {
      this.searchList = [];
      this.form.type = 1;
      this.form.key = null;
    }
    this.jumpType = obj.jumpType;
    if (obj.jumpType == "articleHot") {
      this.labelIds = [obj.labelIds[0].labelId];
      this.checkLabelList = obj.labelIds;
    }
  },
  mounted() {
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getColumnList() {
      apiPost("/business/web/webIndexColumn", {}).then((res) => {
        this.showStyle = res.data[0].showStyle;
        let columnIndex = null;
        res.data.forEach((item, index) => {
          item.count = 0;
          item.activeImg = require(`../assets/imgs/nav-active-icon${
            index > 7 ? index % 8 + 2 : index + 2
          }@2x.png`);
          item.img = require(`../assets/imgs/nav-icon${index > 7 ? index % 8 + 2 : index + 2}@2x.png`);
          if (
              item.iconCheck &&
              (item.iconCheck.indexOf("http") == -1 ||
                item.iconCheck.indexOf("https") == -1)
            ) {
              item.iconCheck = baseUrl + item.iconCheck;
            }
            if (
              item.iconUncheck &&
              (item.iconUncheck.indexOf("http") == -1 ||
                item.iconUncheck.indexOf("https") == -1)
            ) {
              item.iconUncheck = baseUrl + item.iconUncheck;
            }
          if (this.searchList.length > 0) {
            this.searchList.forEach((item1) => {
              if (item.columnId == item1.columnId) {
                item.count = item1.count;
              }
            });
            if (this.jumpType == "search" && this.form.key) {
              this.columnId = this.searchList[0].columnId;
            }
          } else {
            if (this.jumpType == "articleHot") {
              this.columnId = res.data[0].columnId;
            }
          }
          if (this.columnId == item.columnId) {
            // columnIndex = index;
            this.showStyle = res.data[index].showStyle;
          }
        });
        // this.showStyle = columnIndex
        //   ? res.data[columnIndex].showStyle
        //   : res.data[0].showStyle;
        this.columnList = res.data;
        this.getArticleList();
      });
    },
    getLabelList() {
      apiPost("/business/web/webIndexLabel", {}).then((res) => {
        this.labelList = res.data;
      });
    },
    getArticleList() {
      if (!this.searchFlag) {
        this.searchFlag = true;
        apiPost("/business/web/getArticleList", {
          columnId: this.columnId,
          labelIds: this.labelIds ? this.labelIds : [],
          pageNum: this.currentPage,
          pageSize:
            this.showStyle == 0 ? this.listPageSize : this.blockPageSize,
          key: this.form.key ? this.form.key : null,
          type: this.form.key ? this.form.type : null,
          industryConfigType: this.industryConfig.industryConfigType,
          industryConfigId: this.industryConfig.industryConfigId,
        }).then((res) => {
          res.rows.forEach((item) => {
            let str = "";
            item.labelNames.forEach((item1, index) => {
              if (index == item.labelNames.length - 1) {
                str += item1;
              } else {
                str += item1 + " | ";
              }
            });
            item.labelNames = str;
            if (this.showStyle == 1 && item.image != null) {
              if (item.image) {
                if (
                  item.image[0].indexOf("http") == -1 ||
                  item.image[0].indexOf("https") == -1
                ) {
                  item.image[0] = baseUrl + item.image[0];
                }
              }
            }
          });
          this.articleList = res.rows;
          this.total = res.total;
        });
        this.searchFlag = false;
      }
    },
    changeColumn(item, index) {
      if (item == 0) {
        this.columnId = 0;
        this.productFlag = true;
      } else {
        this.columnId = item.columnId;
        this.showStyle = this.columnList[index].showStyle;
        this.labelIds = [];
        this.checkLabelList = [];
        this.currentPage = 1;
      }
      this.getArticleList();
    },
    changeLabel(item) {
      if (this.labelIds.indexOf(item.labelId) == -1) {
        this.labelIds.push(item.labelId);
        this.checkLabelList.push(item);
        this.currentPage = 1;
        this.getArticleList();
      }
    },
    labelsToNull() {
      this.labelIds = [];
      this.checkLabelList = [];
      this.currentPage = 1;
      this.getArticleList();
    },
    labelSplice(index) {
      this.labelIds.splice(index, 1);
      this.checkLabelList.splice(index, 1);
      this.currentPage = 1;
      this.getArticleList();
    },
    handleCascaderChange(value) {
      let industryConfigName = [];
      if (value.length > 1) {
        this.industryConfigList.forEach((item) => {
          if (value.indexOf(item.industryConfigId) != -1) {
            industryConfigName.push(item.name);
            if (item.children) {
              item.children.forEach((item1) => {
                if (value.indexOf(item1.industryConfigId) != -1) {
                  industryConfigName.push(item1.name);
                }
              });
            }
          }
        });
      } else {
        industryConfigName.push(
          this.$refs["cascader"].getCheckedNodes()[0].label
        );
      }
      console.log(industryConfigName);
      let obj = {
        industryConfigType: value.length > 1 ? 2 : 1,
        industryConfigId: value[value.length - 1],
        industryConfigIdList: value,
        name: industryConfigName,
      };
      this.industryConfig = obj;
      this.getArticleList();
      sessionStorage.setItem("industryConfig", JSON.stringify(obj));
      this.$refs.cascader.dropDownVisible = false;
    },
    jumpArticleDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/article",
        name: "article",
        query: { articleId: item.articleId },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 产品预览页文章裂变点击更多 传值操作
    changeProductFlag() {
      this.columnId = this.columnList[0].columnId;
      this.showStyle = this.columnList[0].showStyle;
      this.getArticleList();
      this.productFlag = false;
    },
    inputChange() {
      this.$route.params.key = this.form.key;
      sessionStorage.setItem("pageObj", JSON.stringify(this.$route.params));
    },
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      if (this.showStyle == 0) {
        this.listPageSize = val;
      } else {
        this.blockPageSize = val;
      }
      this.getArticleList();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getArticleList();
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 14px;
  font-family: 思源黑体 Normal;
  font-weight: bold;
  color: #333333;
  padding: 20px;
  padding-bottom: 0;
  margin-top: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.block_ul {
  display: flex;
  flex-wrap: wrap;

  li {
    width: calc((100% - 36px) / 3);
    background: #fff;
    margin-right: 18px;
    margin-top: 18px;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid transparent;

    .image_box {
      padding: 0 20px;
      width: 100%;
      height: 240px;
      display: flex;
      justify-content: center;
      align-content: center;
      cursor: pointer;
      img {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
        // height: 100%;
      }
    }
    p {
      padding: 0 20px;
      width: 100%;
      font-size: 12px;
      font-family: 思源黑体 Normal;
      color: #999999;
      margin: 10px 0;
      cursor: pointer;
      span {
        float: right;
      }
    }
    .bottom_box {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      font-size: 12px;
      font-family: 思源黑体 Normal;
      color: #333333;
      border-top: 1px solid #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      span {
        width: 60px;
        height: 24px;
        background: #4190f6;
        font-size: 12px;
        font-family: 思源黑体 Normal;
        color: #ffffff;
        line-height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 12px;
          height: 12px;
          margin-right: 6px;
          cursor: pointer;
        }
      }
    }
  }
  li:nth-child(3n) {
    margin-right: 0;
  }
  li:nth-child(-n + 3) {
    margin-top: 0;
  }
  li:hover {
    border: 1px solid #4190f6;
  }
}
.point-icon {
  pointer-events: none;
}
</style>

<style>
/* striped先开启斑马纹属性，这里是修改斑马纹颜色 */
.el-table__row--striped td {
  background-color: #f2f2f2 !important;
}

.el-table__row {
  background-color: #ffffff !important;
}

/* 斑马纹颜色定义完之后会显示自带的边框颜色，这里要重置 */
.el-table td,
.building-top .el-table th.is-leaf {
  border: none;
  /* color: white; */
}

.search .el-input input {
  width: 120px;
  height: 32px;
  border: 1px solid #aeaeae;
  border-right: 0;
  border-radius: 0;
}
.search .el-input__icon {
  line-height: 30px;
}
.search .el-input .el-input__inner {
  border-color: #aeaeae !important;
}
.normal-header-inner .el-cascader .el-input__inner {
  border: none !important;
  font-size: 16px;
  color: #333333;
}
</style>